<script>
import genericService from '../../services/genericService';
import NotificationService from '../../services/notifications';

import CommonConstants from '../../common/Constants';

import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Toolbar from 'primevue/toolbar';
import Editor from 'primevue/editor';
import AutoComplete from 'primevue/autocomplete';
import Dropdown from 'primevue/dropdown';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

// const emails = helpers.withMessage('Value is not a valid list of email address', function(items){
//     return !items || (items.every((item) => String(item)
//     .toLowerCase()
//     .match(
//       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//     )));
// });

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar,
    Editor,
    InputText,
    Calendar,
    Dropdown,
    ResponsiveButton,
    AutoComplete
},
  data(){
    return {
      data: {
        creationDate: new Date(),
        notificationDate: new Date(),
        idThread: Number(this.$route.query.thread)
      },
      submitted: false,
      allUsers: [],
      filteredUsers: [],
      options: []
    }
  },
  validations(){
    return {
      data: {
        idThread: {},
        notificationDate: {},
        receivers: { required },
        notificationObject: { required },
        notificationText: { required }
      }
    }
  },
  async mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'notifications.page_title');

    this.getAllUsers();

    if (!this.$store.state.notifications.threads[0]) {
      NotificationService.getThreads(({success, data}) => {
      if(success){
          this.$store.dispatch("notifications/setThreads", data);
          const currentThread = data.find((item) => item.id === Number(this.data.idThread));
          currentThread && (
            this.options = [{label: currentThread?.threadName, value: currentThread?.id}],
            this.data.receivers = [...new Set(Array.isArray(currentThread?.users) ? currentThread?.users : currentThread?.users.split(','))].filter((item) => item !== this.$store.state.security.user.username)
            
            );
      }
      });
    } else {
      const currentThread = this.$store.state.notifications.threads.find((item) => item.id === Number(this.data.idThread));
      currentThread && (
        this.options = [{label: currentThread?.threadName, value: currentThread?.id}],
        this.data.receivers = [...new Set(Array.isArray(currentThread?.users) ? currentThread?.users : currentThread?.users.split(','))].filter((item) => item !== this.$store.state.security.user.username)
        );
    }
  },
  computed: {
      constants(){
          return CommonConstants;
      }
  },
  methods: {
    goBack(){
        this.$router.back();
    },
    onReceiverSelected(event){
        this.data.receivers = (event.value.username);
    },
    async getAllUsers () {
      await genericService.get('security/user').then(({data}) => {
        this.allUsers = data.filter((item) => item.username !== this.$store.state.security.user.username).map((item) => item.username);
      });
    },
    searchUser(event) {
      this.filteredUsers = this.allUsers.filter((el) => el.includes(event.query));
    },
    handleSubmit(valid){
      this.submitted = true;

      if (valid) {
        const body = {
        ...this.data,
        isAutomatic: false,
        creationDate: this.data.notificationDate,
        sender: this.$store.state.security.user.username,
        isModifiableByReceivers: false,
        receivers: [...this.data.receivers, this.$store.state.security.user.username].join(',')
        }
        NotificationService.addNotification(body, ({success}) => {
          success && this.goBack();
        });
      }
    }
  }
}

</script>

<template>
  <main>
    <Toolbar>
      <template #start>
        <ResponsiveButton :label="$t('btn.send')" icon="pi pi-send" class="p-button-sm m-1" @click="handleSubmit(!v$.$invalid)"/>
      </template>
      </Toolbar>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid formgrid">
              <div class="col-12 lg:col-3 field">
                <label for="notificationDate">{{$t('notifications.notificationDate')}}</label>
                <Calendar
                :placeholder="constants.DATE_PLACEHOLDER_POINT"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="true"
                :disabled="true"
                id="notificationDate"
                v-model="data.notificationDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
              </div>
              <div class="col-12 lg:col-3 field">
                <label for="thread">{{$t('thread.page_title')}}</label>
                <Dropdown
                v-model="data.idThread"
                :options="options"
                optionValue="value" 
                optionLabel="label"
                id="thread"
                :disabled="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
              </div>
              <div class="col-12 lg:col-6 field">
                <label for="subject" :class="{'p-error':v$.data.notificationObject.$invalid && submitted}">{{$t('notifications.subject')}}</label>
                <InputText
                id="subject" type="text"
                v-model="data.notificationObject"
                :class="{'p-invalid':v$.data.notificationObject.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <div v-if="(v$.data.notificationObject.$invalid && submitted) || v$.data.notificationObject.$pending.$response">
                  <small class="p-error" v-for="error in v$.data.notificationObject.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div class="col-12 field">
                <label for="receivers" :class="{'p-error':v$.data.receivers.$invalid && submitted}">{{$t('notifications.receivers')}}</label>
                <AutoComplete 
                id="receivers" 
                :multiple="true" 
                type="email" 
                v-model="data.receivers" 
                :suggestions="filteredUsers" 
                @complete="searchUser($event)" 
                :class="{'p-invalid':v$.data.receivers.$invalid && submitted, 'w-full': true}" />
                <div v-if="(v$.data.receivers.$invalid && submitted) || v$.data.receivers.$pending.$response">
                  <small class="p-error" v-for="error in v$.data.receivers.$silentErrors" :key="error.$validator">
                      {{error.$message}}<br>
                  </small>
                </div>
              </div>
              <div class="col-12 lg:col-12 field">
                <label for="message" :class="{'p-error':v$.data.notificationText.$invalid && submitted}">{{$t('notifications.message')}}</label>
                <Editor :disabled="false" id="message" editorStyle="height: 320px" v-model="data.notificationText" />
                <div v-if="(v$.data.notificationText.$invalid && submitted) || v$.data.notificationText.$pending.$response">
                  <small class="p-error" v-for="error in v$.data.notificationText.$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style lang="scss">

  .p-autocomplete {
    .p-autocomplete-multiple-container {
      width: 100%;
    }
  }
</style>